import React from 'react';
import PropTypes from 'prop-types';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import AddIcon from '@mui/icons-material/Add';

export default function AgreementstatusesTableToolbar({ local, onCategoriesClick }) {
  return (
    <GridToolbarContainer>
      <Button variant="text" size="small" color="primary" onClick={onCategoriesClick}>
        {local.categories}
      </Button>
      <Button variant="text" size="small" color="secondary">
        {local.statuses}
      </Button>
      {/* <Button variant="text" size="small" color="primary" onClick={onAddClick}>
        <AddIcon />
        {local.add}
      </Button> */}
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport csvOptions={{ delimiter: ';', utf8WithBom: true }} />
    </GridToolbarContainer>
  );
}

AgreementstatusesTableToolbar.propTypes = {
  local: PropTypes.shape({
    add: PropTypes.string,
    categories: PropTypes.string,
    statuses: PropTypes.string,
  }).isRequired,
  // onAddClick: PropTypes.func.isRequired,
  onCategoriesClick: PropTypes.func.isRequired,
};
